import React from "react"
import {SosAuthor, SosPublication} from "../../../../packages/graphql-layer/src";
import {Maybe} from "graphql/jsutils/Maybe";


export interface Props {
    publication: SosPublication
}

function C039Author(props: Props) {
    const authorsList = props.publication.authors ?? props.publication.vitae;
    let authors = ""
    authorsList?.map((author: Maybe<SosAuthor>, index: number) => {
        if (author) {
            authors += author.name + " " + author.surname
            if (authorsList.length > index + 1) {
                authors += ", "
            }
        }
    })
    return <React.Fragment key={props.publication.id}>{authors}</React.Fragment>
}

export default C039Author